import storage from 'redux-persist/lib/storage';
import type { PersistConfig } from 'redux-persist';

import type { AppState } from './rootReducer';

const persistConfig: PersistConfig<AppState> = {
  key: 'pagaagro-web',
  version: 1,
  storage,
  whitelist: ['login', 'user', 'contracts', 'quotes', 'entitlements'],
};

export default persistConfig;
